import { computed, ref } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useOrgStore } from '@/stores/org'
import { useOrgMembership } from '@/composables/useOrgMembership'

export const TAB_ROUTES = {
  projects: 'OrgProjects',
  layers: 'OrgLayers',
  chats: 'OrgChats',
  reports: 'OrgReportsPage',
  payments: 'OrgPayments'
}

export const tabRoute = (tab, orgId) => ({
  name: TAB_ROUTES[tab] || TAB_ROUTES.projects,
  params: { org_id: orgId }
})

export function useActiveTab() {
  const router = useRouter()
  const route = useRoute()
  const orgStore = useOrgStore()
  const { isOrgMember } = useOrgMembership()

  const orgId = computed(() => parseInt(route.params.org_id))
  const selectedOrgId = computed(() => orgStore.selectedOrg)

  const activeTab = computed(() => {
    let tab = 'projects'
    if (route.name === 'OrgProjects' || route.name === 'OrgProjectPlaces') {
      tab = 'projects'
    } else if (route.name === 'OrgLayers' || route.name === 'LayerCreate' || route.name === 'LayerDetail' || route.name === 'MapMembers' || route.name === 'MapCreate' || route.name === 'MapEdit') {
      tab = 'layers'
    } else if (route.name === 'OrgChats') {
      tab = 'chats'
    } else if (route.name === 'OrgReportsPage' || route.name === 'ReportDetail') {
      tab = 'reports'
    } else if (route.name === 'OrgPayments' || route.name === 'OrgKyc') {
      tab = 'payments'
    }
    if (!isOrgMember.value && (tab === 'layers' || tab === 'chats' || tab === 'reports' || tab === 'payments')) {
      return 'projects'
    }
    return tab
  })

  const orgOnlyTabs = ['layers', 'chats', 'reports', 'payments']
  const isNavigating = ref(false)

  const navigateToTab = async (tab) => {
    if (orgOnlyTabs.includes(tab) && !isOrgMember.value) return
    if (isNavigating.value) return
    isNavigating.value = true

    try {
      const currentOrgId = orgId.value || selectedOrgId.value || await orgStore.resolveSelectedOrg()
      if (!currentOrgId) return

      await router.push(tabRoute(tab, currentOrgId))
    } finally {
      isNavigating.value = false
    }
  }

  return { activeTab, navigateToTab, isNavigating, isOrgMember }
}
